// Inline, hand-drawn-style SVG icons for the teaching empty states (docs/10 #2.5).
// Deliberately not a generic icon set — loose strokes and slight asymmetry so
// they read as illustrative rather than as UI chrome. currentColor throughout
// so callers set tone via CSS (`.empty-icon` = var(--text-3) by default).

import type { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
  width: 72,
  height: 72,
  viewBox: '0 0 72 72',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/** A screen showing a 6-character pairing code — the first thing a new org sees. */
export function ScreenPairIcon() {
  return (
    <svg {...base} className="empty-icon" aria-hidden="true">
      <rect x="9" y="13" width="54" height="34" rx="4" />
      <path d="M27 55h18M36 47v8" />
      <rect x="18" y="22" width="36" height="16" rx="2" opacity="0.5" />
      <text
        x="36"
        y="34"
        textAnchor="middle"
        fontFamily="var(--font-mono)"
        fontSize="9"
        fontWeight="700"
        stroke="none"
        fill="currentColor"
        letterSpacing="1"
      >
        7KQP3M
      </text>
    </svg>
  );
}

/** A photo behind a video frame, with an upload arrow — media of any kind. */
export function MediaUploadIcon() {
  return (
    <svg {...base} className="empty-icon" aria-hidden="true">
      <rect x="8" y="19" width="40" height="30" rx="3" opacity="0.5" />
      <path d="M17 41l7-8 6 6 5-6 8 8" opacity="0.5" />
      <circle cx="19" cy="27" r="2.5" opacity="0.5" />
      <path d="M46 15v22M38 29l8-8 8 8" transform="translate(6,-1)" />
    </svg>
  );
}

/** A stacked list with a play mark — an ordered loop of media. */
export function PlaylistIcon() {
  return (
    <svg {...base} className="empty-icon" aria-hidden="true">
      <path d="M12 20h34M12 32h34M12 44h18" />
      <circle cx="49" cy="46" r="13" opacity="0.9" />
      <path d="M45 41l9 5-9 5z" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** A calendar page with a clock — when and where a playlist plays. */
export function ScheduleIcon() {
  return (
    <svg {...base} className="empty-icon" aria-hidden="true">
      <rect x="9" y="15" width="34" height="32" rx="3" opacity="0.6" />
      <path d="M16 15v-4M36 15v-4M9 24h34" opacity="0.6" />
      <circle cx="47" cy="42" r="15" />
      <path d="M47 34v8l6 4" />
    </svg>
  );
}
